export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9476_DRAFT': 'Draft',
    '_9113_PUBLISHED': 'Published'
};
